// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoGrowTextareaController from "./auto_grow_textarea_controller"
application.register("auto-grow-textarea", AutoGrowTextareaController)

import BackgroundActionController from "./background_action_controller"
application.register("background-action", BackgroundActionController)

import CheckboxEnableController from "./checkbox_enable_controller"
application.register("checkbox-enable", CheckboxEnableController)

import CheckboxListController from "./checkbox_list_controller"
application.register("checkbox-list", CheckboxListController)

import CheckboxlimitController from "./checkboxlimit_controller"
application.register("checkboxlimit", CheckboxlimitController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CookiebotJavascriptController from "./cookiebot_javascript_controller"
application.register("cookiebot-javascript", CookiebotJavascriptController)

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import FileUploadLimitController from "./file_upload_limit_controller"
application.register("file-upload-limit", FileUploadLimitController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FocusOnInvalidController from "./focus_on_invalid_controller"
application.register("focus-on-invalid", FocusOnInvalidController)

import FormChangedController from "./form_changed_controller"
application.register("form-changed", FormChangedController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import LoadingButtonController from "./loading_button_controller"
application.register("loading-button", LoadingButtonController)

import LocationSelectController from "./location_select_controller"
application.register("location-select", LocationSelectController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ProgressBarController from "./progress_bar_controller"
application.register("progress-bar", ProgressBarController)

import PullingController from "./pulling_controller"
application.register("pulling", PullingController)

import RangeController from "./range_controller"
application.register("range", RangeController)

import ReadonlyToggleController from "./readonly_toggle_controller"
application.register("readonly-toggle", ReadonlyToggleController)

import SaveDisableController from "./save_disable_controller"
application.register("save-disable", SaveDisableController)

import ScrollToBottomController from "./scroll_to_bottom_controller"
application.register("scroll-to-bottom", ScrollToBottomController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import StickyController from "./sticky_controller"
application.register("sticky", StickyController)

import ToggleClassController from "./toggle_class_controller"
application.register("toggle-class", ToggleClassController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
